import { Component, OnInit, TemplateRef } from '@angular/core';

import { BsModalService } from 'ngx-bootstrap/modal';
import { Chart_Interface, Empty_Chart_Interface } from 'src/app/Interface/Chart_Interface';

import { Empty_Persone_List_Interface, Persone_List_Interface } from 'src/app/Interface/Persone_List_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { ChartService } from 'src/app/Service/Chart/Chart.service';
import { ChartPersonService } from 'src/app/Service/Chart/ChartPerson.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { PersonService } from 'src/app/Service/Person/Person.service';

@Component({
  selector: 'app-Chart',
  templateUrl: './Chart.component.html',
  styleUrls: ['./Chart.component.scss']
})
export class ChartComponent implements OnInit {

  Token:String=""
  Procssing:boolean=false


  constructor(
    private Chart_Service:ChartService,
    private ChartPerson_Service:ChartPersonService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
    private Person_Service:PersonService,
    private modalService: BsModalService
  ) { }


  DataList_Chart:Array<Chart_Interface>=[]
  Selected_Chart:Chart_Interface=Empty_Chart_Interface()

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');
    this.Nav_Service.CheckValidPage(this.Token,2190).subscribe(
      data=>{
        this.ReadData_Chart()
      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )


  }

  ReadData_Chart(){
    this.Procssing=true
    this.Chart_Service.GetRecord(this.Token).subscribe(
      data=>{
        this.DataList_Chart=data
        this.Procssing=false
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }



  //#region Edit

  modalRef_Edit: any;
  title_edit:String=''
  haghOzviayt_edit:number=0
  positionGrid_edit:number=0
  code_edit:String=''

  OnGet_Edit_Action(template: TemplateRef<any>,item: Chart_Interface) {
    this.Selected_Chart = item
    this.title_edit=this.Selected_Chart.title
    this.haghOzviayt_edit=this.Selected_Chart.haghOzviayt
    this.positionGrid_edit=this.Selected_Chart.positionGrid
    this.Copy_Item_Protocol=Empty_Chart_Interface()
    this.modalRef_Edit = this.modalService.show(template);
  }

  Edit() {
    if (!this.Selected_Chart.title.trim()) {
      this.Alertify_Service.ErrorMessage("Enter the title.")
    }
    else {
      var temp: Chart_Interface = Empty_Chart_Interface()
      temp.id = this.Selected_Chart.id
      temp.parent = this.Selected_Chart.parent
      temp.title = this.title_edit
      temp.haghOzviayt = Number(this.haghOzviayt_edit)
      temp.positionGrid = Number(this.positionGrid_edit)

      this.Chart_Service.AddEdit(temp, this.Token).subscribe(
        data => {
          if (data['id'] == -2) {
            this.Alertify_Service.ErrorMessage("The title already exists at this level.")
          }
          else if (data['id'] == -1) {
            this.Alertify_Service.ErrorMessage("The entered code already exists in the chart.")
          }
          else {
            this.Selected_Chart.title=this.title_edit
            this.Selected_Chart.haghOzviayt=this.haghOzviayt_edit
            this.Selected_Chart.positionGrid=this.positionGrid_edit
            this.Alertify_Service.SuccessMessage("Information updated successfully.")
            this.modalRef_Edit.hide()
          }
        },
        error => {
          localStorage.clear()
          location.reload();

        }
      )
    }
  }

  //#endregion

  //#region Add

  modalRef_Add: any;
  Add_Step_Title: string = ''
  Add_Step_Code: string = ''

  On_Add_Root(template: TemplateRef<any>) {
    var temp: Chart_Interface = Empty_Chart_Interface()
    this.OnGet_Add_Action(template,temp)
  }

  OnGet_Add_Action(template: TemplateRef<any>,item: Chart_Interface) {
    this.Selected_Chart = item
    this.Copy_Item_Protocol=Empty_Chart_Interface()
    this.Add_Step_Title=""
    this.Add_Step_Code=""
    this.modalRef_Add = this.modalService.show(template);
  }

  Add(id: number) {

    if (!this.Add_Step_Title.trim()) {
      this.Alertify_Service.ErrorMessage("Enter the title.")
    }
    else {
      var temp: Chart_Interface = Empty_Chart_Interface()
      temp.title = this.Add_Step_Title


      if (id == 0) {
        temp.parent = this.Selected_Chart.id
      }
      else {
        temp.parent = this.Selected_Chart.parent
      }


      this.Chart_Service.AddEdit(temp, this.Token).subscribe(
        data => {
          if (data.id == -2) {
            this.Alertify_Service.ErrorMessage("The title already exists at this level.")
          }
          else if (data.id == -1) {
            this.Alertify_Service.ErrorMessage("The entered code already exists.")
          }
          else {
            this.Alertify_Service.SuccessMessage("Information saved successfully.")
            this.ReadData_Chart()
            this.modalRef_Add.hide()
          }
        },
        error => {
          localStorage.clear()
          location.reload();

        }
      )
    }
  }

  //#endregion

  //#region Delete

  modalRef_Delete: any;

  OnGet_Remove_Action(template: TemplateRef<any>,item: Chart_Interface) {
    this.Selected_Chart = item
    this.Copy_Item_Protocol=Empty_Chart_Interface()
    this.modalRef_Delete = this.modalService.show(template);
  }

  Delete(id: number) {

    this.Chart_Service.Delete(this.Selected_Chart.id,id, this.Token).subscribe(
      data => {
        this.Alertify_Service.SuccessMessage("Information deleted successfully.")
        this.ReadData_Chart()
        this.modalRef_Delete.hide()
      },
      error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  //#endregion

  //#region Order

  Copy_Item_Protocol: Chart_Interface = Empty_Chart_Interface();
  Copy_Item_Protocol_Up:Number=-1

  OnGet_Up_Action(item: Chart_Interface) {
    this.Copy_Item_Protocol = item
    this.Copy_Item_Protocol_Up = 1
    this.Alertify_Service.SuccessMessage("Select a destination for the move.")
    /*
    this.Chart_Service.UpOrder(item.id, this.Token).subscribe(
      data => {
        this.Alertify_Service.SuccessMessage("Information saved successfully.")
        this.ReadData_Chart()
      }
    )
    */
  }

  OnGet_Down_Action(item: Chart_Interface) {
    this.Copy_Item_Protocol = item
    this.Copy_Item_Protocol_Up = 0
    this.Alertify_Service.SuccessMessage("Select a destination for the move.")
    /*
    this.Chart_Service.DownOrder(item.id, this.Token).subscribe(
      data => {
        this.Alertify_Service.SuccessMessage("Information saved successfully.")
        this.ReadData_Chart()
      }
    )
    */
  }

  OnGet_Child_Action(item: Chart_Interface) {
    this.Copy_Item_Protocol = item
    this.Copy_Item_Protocol_Up = 2
    this.Alertify_Service.SuccessMessage("Select a destination for the move.")
    /*
    this.Chart_Service.DownOrder(item.id, this.Token).subscribe(
      data => {
        this.Alertify_Service.SuccessMessage("Information saved successfully.")
        this.ReadData_Chart()
      }
    )
    */
  }

  OnGet_Cut_Action(item: Chart_Interface) {

    if (this.Copy_Item_Protocol.id == 0) {
      this.Alertify_Service.ErrorMessage("No item has been selected to move.")
    }
    else if (this.Copy_Item_Protocol_Up == 2)
    {
      this.Chart_Service.ChildOrder(this.Copy_Item_Protocol.id,item.id, this.Token).subscribe(
        data => {
          if (data['id'] == -1)
          {
            this.Alertify_Service.ErrorMessage("The item cannot be moved because the levels do not match.")
          }
          else {
            this.Alertify_Service.SuccessMessage("Information saved successfully.")
            this.ReadData_Chart()
            this.Copy_Item_Protocol=Empty_Chart_Interface()
          }

        }
      )
    }
    else {
      this.Chart_Service.CutOrder(this.Copy_Item_Protocol.id,item.id,this.Copy_Item_Protocol_Up==1, this.Token).subscribe(
        data => {
          if (data['id'] == -1)
          {
            this.Alertify_Service.ErrorMessage("The item cannot be moved because the levels do not match.")
          }
          else {
            this.Alertify_Service.SuccessMessage("Information saved successfully.")
            this.ReadData_Chart()
            this.Copy_Item_Protocol=Empty_Chart_Interface()
          }

        }
      )
    }
  }

  //#endregion

  //#region Person

  Swicher_Person_Tree:Chart_Interface=Empty_Chart_Interface()
  OnGet_Person_Action(template: TemplateRef<any>,item: Chart_Interface) {
    this.Swicher_Person_Tree=item
    this.modalRef_Person = this.modalService.show(template);
  }


  OnBack_From_Person() {
    this.Swicher_Person_Tree=Empty_Chart_Interface()
  }


  //#endregion  

  
  //#region  Person
  modalRef_Person: any;
  modalRef_Person_Delete: any;
  Procssing_Person: boolean = false
  Selected_Chart_Person:Persone_List_Interface=Empty_Persone_List_Interface()

  Personpage: number = 0;
  Filter_Familly: string = ''
  Filter_Area: string = ''

  Change_Filter() {
    this.Personpage = 0
  }

  ReadData_Person() {
    this.Procssing_Person = true

    this.Person_Service.GetActive(this.Token).subscribe(
      data => {
        this.DataList_Person = data
        this.Procssing_Person = false
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }

  DataList_Person: Array<Persone_List_Interface> = []

  Set_Selected_Person_Record(item: Persone_List_Interface) {

    var Chekcer: boolean = false
    
    for (let detail of this.Swicher_Person_Tree.person) {
      if (detail.id == item.id ) {
        Chekcer = true
        break
      }
    }

    if (Chekcer) {
      this.Alertify_Service.ErrorMessage("The selected calibration technician is already in the list.")
    }
    else {

      this.modalRef_Person.hide()
      this.ChartPerson_Service.Add(this.Swicher_Person_Tree.id,item.id,this.Token).subscribe(
        data=>{
          if(data['id']==-1)
            this.Alertify_Service.ErrorMessage(item.fullname + " already has the position "+ this.Swicher_Person_Tree.title +".")
          else
          {
            this.Alertify_Service.SuccessMessage(item.fullname + " was assigned the position "+ this.Swicher_Person_Tree.title +".")
            this.ReadData_Chart()
          }
        }
      )
    }

  }

  OnGet_Remove_Person_Action(template: TemplateRef<any>,item: Persone_List_Interface) {
    this.Selected_Chart_Person = item
    this.modalRef_Person_Delete = this.modalService.show(template);
  }

  Delete_Person() {
    this.modalRef_Person_Delete.hide()
    this.ChartPerson_Service.Delete(this.Selected_Chart_Person.codemeli, this.Token).subscribe(
      data => {
        this.Alertify_Service.SuccessMessage("Information deleted successfully.")
        this.ReadData_Chart()

      },
      error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  //#endregion


}
